module.exports = __webpack_public_path__ + "img/l1.50a9fcff.jpg";